import axios from "axios";
import { BASE_URL } from "./Constants";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export async function deleteEpisode(idSerie, idEp) {
  try {
    const response = await instance.delete(`/${idSerie}/episode/${idEp}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function deleteTransitionConfig(projet) {
  try {
    const response = await instance.delete(`/edifice/transition/config/${encodeURIComponent(projet)}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "La surcharge n'a pas pu être supprimée" };
  }
}

export async function deleteCodeUser(code, idUser, body) {
  try {
    const response = await instance.delete(`/manage/webappcode/${encodeURIComponent(code)}/user/${idUser}`, { data: body });
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "Le compte n'a pas pu être retiré" };
  }
}
